module.exports = __webpack_public_path__ + "static/media/ipre.7e525b84.png";